<ng-container *ngIf="viewMode >= 2 && form != null && richTextOfActiveLanguage">
    <!-- Edit Mode -->
    <button class="close dialog-close-button" mat-button (click)="closeDialog()" *ngIf="asDialog">X</button>
    <div [formGroup]="form">
        <ham-tiptap-toolbar
            [editor]="tiptapEditor"
            (imageSelected)="onTiptapImageSelected($event)"
            [disableSticky]="true"
        >
            <div #tiptapHost class="tiptap-editor"></div>
        </ham-tiptap-toolbar>
    </div>
</ng-container>
<ng-container *ngIf="viewMode <= 1">
    <div [innerHTML]="richTextOfActiveLanguage.text | safeHtml"></div>
</ng-container>
